import { render, staticRenderFns } from "./FormulaListLeft.vue?vue&type=template&id=72738899&scoped=true"
import script from "./FormulaListLeft.vue?vue&type=script&lang=js"
export * from "./FormulaListLeft.vue?vue&type=script&lang=js"
import style0 from "./FormulaListLeft.vue?vue&type=style&index=0&id=72738899&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72738899",
  null
  
)

export default component.exports